import { render } from "./FPluginPermissionrecordno.vue?vue&type=template&id=aff5010e&scoped=true"
import script from "./FPluginPermissionrecordno.vue?vue&type=script&lang=js"
export * from "./FPluginPermissionrecordno.vue?vue&type=script&lang=js"

import "./FPluginPermissionrecordno.vue?vue&type=style&index=0&id=aff5010e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aff5010e"]])

export default __exports__